import React, { memo } from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import componentPropType from '@signal/prop-types/component';
import renderIf from '@signal/utils/renderIf';
import Brand from '../Brand';
import { Header, Left, AppIconWrapper, AppTitle, Middle } from './styles'; // standard header to use in desktop apps, showing a multiapp menu next to the PureCars icon

export function DesktopHeader(_ref) {
  var children = _ref.children,
      AppIcon = _ref.icon,
      hideLogo = _ref.hideLogo,
      title = _ref.title,
      isPageChild = _ref.isPageChild,
      fullWidth = _ref.fullWidth,
      alignIcon = _ref.alignIcon,
      LeftComponent = _ref.LeftComponent,
      HeaderComponent = _ref.HeaderComponent,
      MiddleComponent = _ref.MiddleComponent,
      MultiAppNavMenu = _ref.MultiAppNavMenu,
      RightHandMenu = _ref.RightHandMenu;

  var LeftContent = function LeftContent() {
    return /*#__PURE__*/React.createElement(LeftComponent, {
      alignIcon: alignIcon
    }, renderIf(MultiAppNavMenu, function () {
      return /*#__PURE__*/React.createElement(MultiAppNavMenu, null);
    }), renderIf(!hideLogo, function () {
      return /*#__PURE__*/React.createElement(AppIconWrapper, null, /*#__PURE__*/React.createElement(AppIcon, null));
    }));
  };

  return /*#__PURE__*/React.createElement(HeaderComponent, {
    isPageChild: isPageChild,
    left: MultiAppNavMenu || !hideLogo ? LeftContent : undefined,
    constrainWidth: !fullWidth,
    fixed: true
  }, /*#__PURE__*/React.createElement(MiddleComponent, null, renderIf(title && isString(title), /*#__PURE__*/React.createElement(AppTitle, null, title), title), children, /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1
    }
  }), renderIf(RightHandMenu, function () {
    return /*#__PURE__*/React.createElement(RightHandMenu, null);
  })));
}
DesktopHeader.propTypes = {
  alignIcon: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  fullWidth: PropTypes.bool,
  icon: componentPropType,
  isPageChild: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, componentPropType]),
  HeaderComponent: componentPropType,
  LeftComponent: componentPropType,
  MiddleComponent: componentPropType,
  MultiAppNavMenu: componentPropType,
  RightHandMenu: componentPropType
};
DesktopHeader.defaultProps = {
  alignIcon: 'right',
  icon: Brand,
  title: '',
  HeaderComponent: Header,
  LeftComponent: Left,
  MiddleComponent: Middle
};
export default /*#__PURE__*/memo(DesktopHeader);